$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

// Set a default loader with a funky spinner for our modals!
$.extend(true, $.magnificPopup.defaults, {
    tLoading: '<i class="fa fa-circle-o-notch fa-spin"></i> Loading...'
});

$(document).ready(function () {
    $('.hidden-without-js').removeClass('hidden-without-js');

    $("body").magnificPopup({
        delegate: "a[data-action='open-ajax-modal']",
        type: 'ajax',
        callbacks: {
            ajaxContentAdded: function (response) {
                var $modal = $('.mfp-content');

                // Look for parsley forms and bind em if found
                if ($modal.find('.parsley-form').length) {
                    $form = $modal.find('.parsley-form');

                    bindForm($form);
                }
            }
        }
    });

    $("[data-parsley-form]").each( function() {
       bindForm($(this));
    });

    $("a[data-action='open-inline-modal']").magnificPopup({
        type: 'inline',
        midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    $(this).on('click', "a[data-action='submit-form'], button[data-action='submit-form']", function (event) {
        event.preventDefault();

        var $form = $($(this).data("form-id"));
        $form.submit();
    });

    $(this).on('click', "a[data-action='close-modal'], button[data-action='close-modal']", function(event) {
        event.preventDefault();

        $.magnificPopup.close();
    });

    $(this).on('submit', "form[data-submit-method='ajax']", function(event) {
        event.preventDefault();

        var $form = $(this);
        var url = $form.prop('action');
        var method = $form.prop('method');
        var $loader = $form.find('.loader');
        var $result = $form.find('.form-result');
        var $actions = $form.find('.form-actions');
        var $formContent = $form.find('.form-content');
        var $generalError = $form.find('.general-error');

        var hideForm = $(this).data('ajax-hide-form');
        var timeoutErrorTitle = $(this).data('timeout-error-title');
        if (!timeoutErrorTitle) {
            timeoutErrorTitle = 'Request is taking a bit longer than we expected.';
        }
        var timeoutErrorMessage = $(this).data('timeout-error-message');
        if (!timeoutErrorMessage) {
            timeoutErrorMessage = 'If you need to contact us, send an email to <a href="mailto:neosales@idexx.com">neosales@idexx.com</a> or call us at <a href="tel:+1-888-433-9963">1-888-IDEXX-NEO</a>.';
        }

        $.ajax({
            url: url,
            timeout: 45000,
            method: method,
            dataType: 'json',
            data: $form.serialize(),
            beforeSend: function() {
                $loader.show();
                $actions.hide();
                $result.empty().hide();
                if(hideForm) {
                    $formContent.hide();
                }
            },
            success: function (response) {
                $formContent.hide();
                $result.html(response.message ? response.message : 'success').show().addClass('animate-result');
            },
            error: function (xhr, status) {
                $formContent.hide();
                if (status == 'timeout') {
                    $result.html('<div class="centered">' +
                            '<h2><i class="fa fa-exclamation-triangle"></i>' + timeoutErrorTitle +'</h2>' +
                            '<p>' + timeoutErrorMessage + '</p>' +
                            '</div>')
                        .show().addClass('animate-result');
                    if(typeof Raven !== 'undefined'){
                        Raven.captureMessage('Timeout submitting form', {
                            level: 'warning',
                            extra: {url: url}
                        })
                    }
                } else {
                    $generalError.show();
                }
            },
            complete: function() {
                $loader.hide();
            }
        });
    });
});

function changeButtonToLoading($button) {
    $button.html('<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;loading');
}